<template>
	<div v-if="showFullScreenBtn" class="full-screen-btn-con">
		<Tooltip :content="value ? '退出全屏' : '全屏'" placement="bottom">
			<Icon @click.native="handleChange" :type="value ? 'md-contract' : 'md-expand'" :size="23"></Icon>
		</Tooltip>
	</div>
</template>

<script>
	export default {
		name: 'Fullscreen',
		computed: {
			showFullScreenBtn() {
				return window.navigator.userAgent.indexOf('MSIE') < 0
			}
		},
		props: {
			value: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			handleFullscreen() {
				let main = document.body
				if(this.value) {
					if(document.exitFullscreen) {
						document.exitFullscreen()
					} else if(document.mozCancelFullScreen) {
						document.mozCancelFullScreen()
					} else if(document.webkitCancelFullScreen) {
						document.webkitCancelFullScreen(() => {
							return this.value = true
						})
					} else if(document.msExitFullscreen) {
						document.msExitFullscreen()
					}
				} else {
					if(main.requestFullscreen) {
						main.requestFullscreen()
					} else if(main.mozRequestFullScreen) {
						main.mozRequestFullScreen()
					} else if(main.webkitRequestFullScreen) {
						main.webkitRequestFullScreen()
					} else if(main.msRequestFullscreen) {
						main.msRequestFullscreen()
					}
				}
			},
			handleChange() {
				this.handleFullscreen()
			}
		},
		mounted() {
			document.onkeydown = (event) => { //监听整个键盘的onkeydown事件
				if(event.keyCode == 122) {
					event.preventDefault(); //阻止浏览器的默认行为
					this.handleFullscreen(); //调用H5的api
				}
			};

			let isFullscreen = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen
			isFullscreen = !!isFullscreen
			document.addEventListener('fullscreenchange', () => {
				this.$emit('input', !this.value)
				this.$emit('on-change', !this.value)
			})
			document.addEventListener('mozfullscreenchange', () => {
				this.$emit('input', !this.value)
				this.$emit('on-change', !this.value)
			})
			document.addEventListener('webkitfullscreenchange', () => {
				this.$emit('input', !this.value)
				this.$emit('on-change', !this.value)
			})
			document.addEventListener('msfullscreenchange', () => {
				this.$emit('input', !this.value)
				this.$emit('on-change', !this.value)
			})
			this.$emit('input', isFullscreen)
		}
	}
</script>

<style lang="less">

</style>


// WEBPACK FOOTER //
// src/components/main/common/fullscreen.vue